import * as React from 'react';

// tslint:disable:max-line-length
export const ParkingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M15 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm-4.556 8.588c-.823.618-1.84.92-2.868.854h-.909V13H4.548V3H7.74a4.242 4.242 0 0 1 2.765.783c.66.589 1.01 1.451.947 2.334.06.935-.31 1.845-1.008 2.471zM7.631 4.739h-.964v2.967h.7a2.32 2.32 0 0 0 1.463-.387c.33-.275.51-.69.483-1.119a1.387 1.387 0 0 0-.407-1.1 1.9 1.9 0 0 0-1.275-.361z"
    />
  </svg>
);
